/**
 * Maps a backend error `code` (see backend/internal/kit/errors and
 * backend/internal/kit/server/intercept/errors.go for the JSON shape:
 * `{ code, message, status, errors? }`) to a translated UI message, falling
 * back to a generic translated message for codes the UI doesn't special-case.
 */
import type { AxiosError } from "axios";
import { i18n } from "@/i18n";

interface ApiErrorBody {
  code?: string;
  message?: string;
}

export function translateApiError(error: unknown): string {
  const code = (error as AxiosError<ApiErrorBody> | undefined)?.response?.data?.code;
  const { t, te } = i18n.global;
  if (code && te(`errors.${code}`)) {
    return t(`errors.${code}`);
  }
  return t("errors.generic");
}
